/** ***
------------------------------------------------------------------------
CLOUD DISCOVERY LIST PAGE
------------------------------------------------------------------------
  'name': 'prod2-us-east-1-cohnreznick1-airflow',
  'instanceId': 'i-0376b91db0ed7fc29',
  'instanceState': 'Stopped',
  'instanceType': 't3.medium',
  'availabilityZone': 'us-east-1d',
  'publicIPv4Dns': '-',
  'publicIPv4Address': '-',
  'elasticIp': '-',
  'ipv6Ips': [],
  'securityGroupName': ['launch-wizard-1,prod2-us-east-1-cohnreznick1-cluster-sg'],
  'keyName': 'confluera',
  'launchTime': '2020/03/26 10:09 GMT-7'

  data :
  agentId: null
  instanceId: "i-0376b91db0ed7fc29"
  instanceType: "t3.medium"
  managed: false
  monitoringState: null
  privateIpAddress: "172.31.8.167"
  publicIpAddress: null
  state: "stopped"

** ***/

const cloudDiscoveryMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Name',
        label: 'Name',
        sortable: true,
        'min-width': 250,
        name: 'name'
      },
      {
        datatype: 'string',
        description: 'Agent Id',
        label: 'Agent Id',
        sortable: true,
        'min-width': 150,
        name: 'agentId'
      },
      {
        datatype: 'string',
        description: 'Instance ID',
        label: 'Instance ID',
        sortable: true,
        'min-width': 175,
        name: 'instanceId'
      },
      {
        datatype: 'string',
        description: 'Instance State',
        label: 'Instance State',
        sortable: true,
        'min-width': 150,
        name: 'state'
      },
      {
        datatype: 'string',
        description: 'Instance Type',
        label: 'Instance Type',
        sortable: true,
        'min-width': 150,
        name: 'instanceType'
      },
      {
        datatype: 'string',
        description: 'Agent Installed',
        label: 'Managed',
        sortable: true,
        'min-width': 100,
        name: 'managed'
      },
      {
        datatype: 'string',
        description: 'Ports Opened to Public Internet',
        label: 'Ports Opened to Public Internet',
        sortable: true,
        'min-width': 100,
        name: 'openToPublicInternet'
      },
      {
        datatype: 'string',
        description: 'Agent State',
        label: 'Monitoring State',
        sortable: true,
        'min-width': 150,
        name: 'monitoringState'
      },
      {
        datatype: 'string',
        description: 'Private IP Address',
        label: 'Private IP Address',
        sortable: true,
        'min-width': 150,
        name: 'privateIpAddress'
      },
      {
        datatype: 'string',
        description: 'Public IP Address',
        label: 'Public IP Address',
        sortable: true,
        'min-width': 150,
        name: 'publicIpAddress'
      }
    ]
  }
}

export { cloudDiscoveryMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/hosts/clouddiscovery-meta.js